// Login View urls
export const ACE_URL = {
  au: "https://www.acerentalcars.com.au/",
  nz: "https://www.acerentalcars.co.nz/",
};
export const ACE_ONLINE_CHECK_IN = {
  au: "https://www.acerentalcars.com.au/checkin",
  nz: "https://www.acerentalcars.co.nz/checkin",
};
export const ACE_PRODUCTS_AND_SERVICES = {
  au: "https://www.acerentalcars.com.au/information/car-rental-accessories",
  nz: "https://www.acerentalcars.co.nz/information/car-rental-accessories",
};
export const ACE_FLEET_GUIDE = {
  au: "https://www.acerentalcars.com.au/our-cars",
  nz: "https://www.acerentalcars.co.nz/our-cars",
};
export const ACE_LOCATIONS = {
  au: "https://www.acerentalcars.com.au/locations/car-hire-locations",
  nz: "https://www.acerentalcars.co.nz/locations/new-zealand-rental-car-locations",
};

export const HERTZ_URL = {
  au: "https://www.hertz.com.au/",
  nz: "https://www.hertz.co.nz/",
};
export const HERTZ_PRODUCTS_AND_SERVICES = {
  au: "https://www.hertz.com.au/rentacar/productsandservices/productsandservicesRegions.do",
  nz: "https://www.hertz.co.nz/rentacar/productsandservices/productsandservicesRegions.do",
};
export const HERTZ_FLEET_GUIDE = {
  au:
    "https://www.hertz.com.au/rentacar/vehicleguide/index.jsp?targetPage=vehicleGuideHomeView.jsp&countryCode=AU&category=Car/Sedan",
  nz:
    "https://www.hertz.co.nz/rentacar/vehicleguide/index.jsp?targetPage=vehicleGuideHomeView.jsp&countryCode=NZ&category=Car/Sedan",
};
export const HERTZ_PRIVACY_POLICY =
  "https://www.hertz.com/rentacar/privacypolicy/index.jsp?targetPage=privacyPolicyView.jsp";
export const HERTZ_FLEET_URL = "https://hertzfleet.com.au/";
export const HERTZ_LOCATIONS = {
  au: "https://www.hertz.com.au/rentacar/location",
  nz: "https://www.hertz.co.nz/rentacar/location",
};
export const HERTZ_INVOICE_EXPLAINED = "https://images.hertz.com/pdfs/au_invoice_explained.pdf";
export const HERTZ_JOIN_GOLD_MEMBER =
  "https://www.hertz.com.au/rentacar/emember/join/overview.do?learnMore=gold";
export const HERTZ_FAQ = {
  au: "https://hertz.force.com/care/htz_faqsearchwebform?lang=AU&pos=AU",
  nz: "https://hertz.force.com/care/htz_faqsearchwebform?lang=AU&pos=AU",
};

export const FIREFLY_URL = "https://www.fireflycarrental.com/rentalcar/reservation/home";
export const FIREFLY_LOCATIONS =
  "https://www.fireflycarrental.com/rentalcar/locations/index.jsp?targetPage=locationsListView.jsp";

// Login View icons
// ACE
export const ACE_URL_LOGO =
  "https://s3-ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/hertz-style-guide/logos/ace_rental_cars_logo_400.jpg";
export const ACE_URL_ICON =
  "https://s3-ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/hertz-style-guide/icons/ace/OTHER COUNTRIES_Click+Ace.png";
export const ACE_ONLINE_CHECK_IN_ICON =
  "https://s3-ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/hertz-style-guide/icons/H_Iconography_Loyalty_Join_Transparent.png";
export const ACE_PRODUCTS_AND_SERVICES_ICON =
  "https://s3-ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/hertz-style-guide/icons/ace/Loyalty_Cash-and-Points+Ace.png";
export const ACE_FLEET_GUIDE_ICON =
  "https://s3-ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/hertz-style-guide/icons/ace/Loyalty_Select-your-Car+Ace.png";
export const ACE_LOCATIONS_ICON =
  "https://s3-ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/hertz-style-guide/icons/ace/OTHER COUNTRIES_Parking+Ace.png";
export const ACE_FAVICON_HREF =
  "https://s3-ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/hertz-style-guide/favicon/Ace-AU-favicon.png";
export const ACE_LOGIN_BANNER =
  "https://s3-ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/hertz-style-guide/images/MJP+sign+in-Ace.jpg";
export const ACE_ONLINE_CHECKIN_BANNER =
  "https://s3-ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/hertz-style-guide/images/ONLINE+CHECKIN+BANNER+ACE.jpg";
export const ACE_RENTAL_EXTENSION_BANNER =
  "https://s3-ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/hertz-style-guide/images/RENTAL-EXTENSION-BANNER-ACE.jpg";

// HERTZ
export const HERTZ_URL_LOGO =
  "https://s3-ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/hertz-style-guide/logos/Hertz_Primary_Logo_Black_Yellow+Line_RGB.png";
export const HERTZ_URL_ICON =
  "https://s3-ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/hertz-style-guide/icons/H_Iconography_OTHER COUNTRIES_Click_Transparent.png";
export const HERTZ_PRODUCTS_AND_SERVICES_ICON =
  "https://s3-ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/hertz-style-guide/icons/H_Iconography_Loyalty_Cash-and-Points_Transparent.png";
export const HERTZ_FLEET_GUIDE_ICON =
  "https://s3-ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/hertz-style-guide/icons/H_Iconography_Loyalty_Select-your-Car_Transparent.png";
export const HERTZ_LOCATIONS_ICON =
  "https://s3-ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/hertz-style-guide/icons/H_Iconography_OTHER COUNTRIES_Parking_Transparent.png";
export const HERTZ_FAQ_ICON =
  "https://s3-ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/hertz-style-guide/icons/Herts+FAQ.png";
export const HERTZ_LOGIN_BANNER =
  "https://s3-ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/hertz-style-guide/images/MJP-Sign-In-Banner.jpg";
export const HERTZ_ONLINE_CHECKIN_LOGIN_BANNER =
  "https://s3-ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/hertz-style-guide/images/ONLINE-CHECKIN-BANNER.jpg";
export const HERTZ_RENTAL_EXTENSION_BANNER =
  "https://s3-ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/hertz-style-guide/images/RENTAL-EXTENSION-BANNER.jpg";

// FIREFLY
export const FIREFLY_URL_LOGO =
  "https://s3-ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/hertz-style-guide/logos/firefly_logo_final.png";
export const FIREFLY_URL_ICON =
  "https://s3-ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/hertz-style-guide/icons/firefly/OTHER COUNTRIES_Click+Firefly.png";
export const FIREFLY_LOCATIONS_ICON =
  "https://s3-ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/hertz-style-guide/icons/firefly/OTHER COUNTRIES_Parking+Firefly.png";
export const FIREFLY_FAVICON_HREF =
  "https://s3-ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/hertz-style-guide/favicon/firefly-favicon.ico";
export const FIREFLY_LOGIN_BANNER =
  "https://s3-ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/hertz-style-guide/images/MJP+sign+in-FF.jpg";

//DOLLAR

export const DOLLAR_LOGIN_BANNER =
  "https://s3.ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/hertz-style-guide/images/MJP+sign+in-Dollar.jpg";
export const DOLLAR_ONLINE_CHECKIN_BANNER =
  "https://s3.ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/hertz-style-guide/images/ONLINE+CHECKIN+BANNER+Dollar.jpg";
export const DOLLAR_FAVICON_HREF =
  "https://s3.ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/hertz-style-guide/favicon/dollar-favicon.ico";
export const DOLLAR_RENTAL_EXTENSION_BANNER =
  "https://s3.ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/hertz-style-guide/images/RENTAL-EXTENSION-BANNER-Dollar.jpg";

//Thrifty

export const THRIFTY_LOGIN_BANNER =
  "https://s3.ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/hertz-style-guide/images/MJP+sign+in-Thrifty.jpg";
export const THRIFTY_ONLINE_CHECKIN_BANNER =
  "https://s3.ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/hertz-style-guide/images/ONLINE+CHECKIN+BANNER+Thrifty.jpg";
export const THRIFTY_FAVICON_HREF =
  "https://s3.ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/hertz-style-guide/favicon/Thrifty-favicon.ico";
export const THRIFTY_RENTAL_EXTENSION_BANNER =
  "https://s3.ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/hertz-style-guide/images/RENTAL-EXTENSION-BANNER-Thrifty.jpg";

// T&C urls
export const HERTZ_TERMS_AU = "https://www.hertz.com.au/terms";
export const HERTZ_TERMS_NZ = "https://www.hertz.co.nz/terms";
export const ACE_TERMS_AU = "https://www.acerentalcars.com.au/terms";
export const ACE_TERMS_NZ = "https://www.acerentalcars.co.nz/terms";

export const HERTZ_TERMS_AU_PDF = "https://images.hertz.com/pdfs/RT_FULL_AU_EN.pdf";
export const HERTZ_TERMS_NZ_PDF = "https://images.hertz.com/pdfs/RT_FULL_NZ_EN.pdf";
// export const ACE_TERMS_AU_PDF = "https://acerte.s3.ap-southeast-2.amazonaws.com/media/nz/Files%20and%20PDFs/ac22-0004-tcs-update-may-22-au.pdf";
// export const ACE_TERMS_NZ_PDF = "https://acerte.s3.ap-southeast-2.amazonaws.com/media/nz/Files%20and%20PDFs/ac22-0004-tcs-update-may-22-nz.pdf";
export const ACE_TERMS_AU_PDF =
  "https://s3.ap-southeast-2.amazonaws.com/sign-prod.hertz.asiapac.io/assets/files/Ace_AU_NZ_T%26C_NOV_23.pdf";
export const ACE_TERMS_NZ_PDF =
  "https://s3.ap-southeast-2.amazonaws.com/sign-prod.hertz.asiapac.io/assets/files/Ace_AU_NZ_T%26C_NOV_23.pdf";

export const FIREFLY_TERMS_AU = "https://www.fireflycarrental.com/termsAU";
export const FIREFLY_TERMS_NZ =
  "https://images.hertz.com/pdfs/Firefly_New_Zealand_Terms_and_Conditions.pdf";
export const DOLLAR_TERMS_AU =
  "https://s3.ap-southeast-2.amazonaws.com/sign-prod.hertz.asiapac.io/assets/files/HER0089_Dollar_T%26Cs_DEC_2021_A4_Digital_PFO.pdf";
export const THRIFTY_TERMS_AU =
  "https://s3.ap-southeast-2.amazonaws.com/sign-prod.hertz.asiapac.io/assets/files/HER0089_Thrifty_T%26Cs_DEC_2021_A4_Digital_PFO.pdf";
export const DOLLAR_TERMS_NZ =
  "https://s3.ap-southeast-2.amazonaws.com/sign-prod.hertz.asiapac.io/assets/files/HER0089_Dollar_NZ_T%26Cs_DEC_2021_A4_Digital_PFO.pdf";
export const THRIFTY_TERMS_NZ =
  "https://s3.ap-southeast-2.amazonaws.com/sign-prod.hertz.asiapac.io/assets/files/HER0089_Thrifty_NZ_T%26Cs_DEC_2021_A4_Digital_PFO.pdf";

// Footer Copy
export const ACE_FOOTER_COPY = "";
export const HERTZ_FOOTER_COPY = "";
export const FIREFLY_FOOTER_COPY = "";

// Assets
export const PDF_ICON =
  "https://s3-ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/hertz-style-guide/icons/placeholder-pdf-300x300.jpg";

export const COUNTRY = [
  { value: "AU", label: "AUSTRALIA" },
  { value: "NZ", label: "NEW ZEALAND" },
];

//Verify Error Messages:
export const VERIFY_ERROR_MESSAGES = [
  {
    error: "OverallFail",
    message:
      "The document you have provided has been flagged. Please make sure that the document is valid and of readable quality. If you continue to experience issues please head to the counter on arrival to complete the check-in process. Please have your ID with you at time of arrival.",
  },
  {
    error: "FaceMatch",
    message:
      "Facial authentication failed. The photo you have provided does not match your verification document.",
  },
  {
    error: "Liveness",
    message:
      "Facial authentication failed. The photo you have provided does not match your verification document.",
  },
  {
    error: "Over21",
    message:
      "You do not meet our driver's age requirement. You must be 21 years of age or older to rent a vehicle from Hertz.",
  },
  {
    error: "DVS",
    message:
      "The details provided do not match government records. Please ensure that this information is correct before proceeding.",
  },
  { error: "dlExpired", message: "Your ID document is expired." },
  {
    error: "Name",
    message:
      "Your ID document name does not match the booking name.  As we were unable to validate your details please head to the counter on arrival to complete the check in process. Please have your ID with you at time of arrival.",
  },
  {
    error: "LearnerPermit",
    message:
      "Learner's permits are inadmissible. Drivers must have a Provisional or full driver's license.",
  },
  {
    error: "FetchFailed",
    message: "We're unable to get verification result this time, please click refresh to try again",
  },
  {
    error: "FailedToFinaliseIdverification",
    message:
      "Your ID document verification result can't be finalised. Please head to the counter on arrival to complete the check-in process. Please have your ID with you at time of arrival.",
  },
  {
    error: "Learner",
    message:
      "Learner's permits are inadmissible. Drivers must have a provisional or full driver's licence.",
  },
];

// Regions
export const REGIONS = [
  { value: "WA", label: "WESTERN AUSTRALIA", country: "AUSTRALIA" },
  { value: "VI", label: "VICTORIA", country: "AUSTRALIA" },
  { value: "TS", label: "TASMANIA", country: "AUSTRALIA" },
  { value: "SA", label: "SOUTH AUSTRALIA", country: "AUSTRALIA" },
  { value: "QL", label: "QUEENSLAND", country: "AUSTRALIA" },
  { value: "NT", label: "NORTHERN TERRITORY", country: "AUSTRALIA" },
  { value: "NS", label: "NEW SOUTH WALES", country: "AUSTRALIA" },
  { value: "AC", label: "AUSTRALIAN CAPITAL TERRITORY", country: "AUSTRALIA" },
  { value: "CH", label: "SWITZERLAND", country: "OTHER COUNTRIES" },
  { value: "SE", label: "SWEDEN", country: "OTHER COUNTRIES" },
  { value: "SZ", label: "SWAZILAND", country: "OTHER COUNTRIES" },
  { value: "SJ", label: "SVALBARD AND JAN MEYEN ISLANDS", country: "OTHER COUNTRIES" },
  { value: "SR", label: "SURINAME", country: "OTHER COUNTRIES" },
  { value: "SD", label: "SUDAN", country: "OTHER COUNTRIES" },
  { value: "PM", label: "ST. PIERRE AND MIQUELON", country: "OTHER COUNTRIES" },
  { value: "SH", label: "ST. HELENA", country: "OTHER COUNTRIES" },
  { value: "LK", label: "SRI LANKA", country: "OTHER COUNTRIES" },
  { value: "ES", label: "SPAIN", country: "OTHER COUNTRIES" },
  { value: "GS", label: "STH GEORGIA & STH SANDWICH ISL", country: "OTHER COUNTRIES" },
  { value: "ZA", label: "SOUTH AFRICA", country: "OTHER COUNTRIES" },
  { value: "SO", label: "SOMALIA", country: "OTHER COUNTRIES" },
  { value: "SB", label: "SOLOMON ISLANDS", country: "OTHER COUNTRIES" },
  { value: "SI", label: "SLOVENIA", country: "OTHER COUNTRIES" },
  { value: "SK", label: "SLOVAKIA (SLOVAK REPUBLIC)", country: "OTHER COUNTRIES" },
  { value: "SG", label: "SINGAPORE", country: "OTHER COUNTRIES" },
  { value: "SL", label: "SIERRA LEONE", country: "OTHER COUNTRIES" },
  { value: "SC", label: "SEYCHELLES", country: "OTHER COUNTRIES" },
  { value: "SN", label: "SENEGAL", country: "OTHER COUNTRIES" },
  { value: "SU", label: "SAUDI ARABIA", country: "OTHER COUNTRIES" },
  { value: "ST", label: "SAO TOME AND PRINCIPE", country: "OTHER COUNTRIES" },
  { value: "SM", label: "SAN MARINO", country: "OTHER COUNTRIES" },
  { value: "WS", label: "SAMOA", country: "OTHER COUNTRIES" },
  { value: "LC", label: "SAINT LUCIA", country: "OTHER COUNTRIES" },
  { value: "KN", label: "SAINT KITTS AND NEVIS", country: "OTHER COUNTRIES" },
  { value: "RW", label: "RWANDA", country: "OTHER COUNTRIES" },
  { value: "RU", label: "RUSSIAN FEDERATION", country: "OTHER COUNTRIES" },
  { value: "RO", label: "ROMANIA", country: "OTHER COUNTRIES" },
  { value: "RE", label: "REUNION", country: "OTHER COUNTRIES" },
  { value: "QA", label: "QATAR", country: "OTHER COUNTRIES" },
  { value: "PR", label: "PUERTO RICO", country: "OTHER COUNTRIES" },
  { value: "PT", label: "PORTUGAL", country: "OTHER COUNTRIES" },
  { value: "PL", label: "POLAND", country: "OTHER COUNTRIES" },
  { value: "PN", label: "PITCAIRN", country: "OTHER COUNTRIES" },
  { value: "PH", label: "PHILIPPINES", country: "OTHER COUNTRIES" },
  { value: "PE", label: "PERU", country: "OTHER COUNTRIES" },
  { value: "PY", label: "PARAGUAY", country: "OTHER COUNTRIES" },
  { value: "PG", label: "PAPUA NEW GUINEA", country: "OTHER COUNTRIES" },
  { value: "PA", label: "PANAMA", country: "OTHER COUNTRIES" },
  { value: "PS", label: "PALESTINIAN TERRITORY OCCUPIED", country: "OTHER COUNTRIES" },
  { value: "PW", label: "PALAU", country: "OTHER COUNTRIES" },
  { value: "PK", label: "PAKISTAN", country: "OTHER COUNTRIES" },
  { value: "OM", label: "OMAN", country: "OTHER COUNTRIES" },
  { value: "NO", label: "NORWAY", country: "OTHER COUNTRIES" },
  { value: "MP", label: "NORTHERN MARIANA ISLANDS", country: "OTHER COUNTRIES" },
  { value: "NF", label: "NORFOLK ISLAND", country: "OTHER COUNTRIES" },
  { value: "NU", label: "NIUE", country: "OTHER COUNTRIES" },
  { value: "NG", label: "NIGERIA", country: "OTHER COUNTRIES" },
  { value: "NE", label: "NIGER", country: "OTHER COUNTRIES" },
  { value: "NI", label: "NICARAGUA", country: "OTHER COUNTRIES" },
  { value: "NZ", label: "NEW ZEALAND", country: "NEW ZEALAND" },
  { value: "NC", label: "NEW CALEDONIA", country: "OTHER COUNTRIES" },
  { value: "AN", label: "NETHERLANDS ANTILLES", country: "OTHER COUNTRIES" },
  { value: "NL", label: "NETHERLANDS", country: "OTHER COUNTRIES" },
  { value: "NP", label: "NEPAL", country: "OTHER COUNTRIES" },
  { value: "NR", label: "NAURU", country: "OTHER COUNTRIES" },
  { value: "NA", label: "NAMIBIA", country: "OTHER COUNTRIES" },
  { value: "MM", label: "MYANMAR", country: "OTHER COUNTRIES" },
  { value: "MZ", label: "MOZAMBIQUE", country: "OTHER COUNTRIES" },
  { value: "MA", label: "MOROCCO", country: "OTHER COUNTRIES" },
  { value: "MS", label: "MONTSERRAT", country: "OTHER COUNTRIES" },
  { value: "MN", label: "MONGOLIA", country: "OTHER COUNTRIES" },
  { value: "MC", label: "MONACO", country: "OTHER COUNTRIES" },
  { value: "MD", label: "MOLDOVA REPUBLIC OF", country: "OTHER COUNTRIES" },
  { value: "FM", label: "MICRONESIA FEDERATED STATES OF", country: "OTHER COUNTRIES" },
  { value: "MX", label: "MEXICO", country: "OTHER COUNTRIES" },
  { value: "YT", label: "MAYOTTE", country: "OTHER COUNTRIES" },
  { value: "MU", label: "MAURITIUS", country: "OTHER COUNTRIES" },
  { value: "MR", label: "MAURITANIA", country: "OTHER COUNTRIES" },
  { value: "MQ", label: "MARTINIQUE", country: "OTHER COUNTRIES" },
  { value: "MT", label: "MALTA", country: "OTHER COUNTRIES" },
  { value: "ML", label: "MALI", country: "OTHER COUNTRIES" },
  { value: "MV", label: "MALDIVES", country: "OTHER COUNTRIES" },
  { value: "MY", label: "MALAYSIA", country: "OTHER COUNTRIES" },
  { value: "MW", label: "MALAWI", country: "OTHER COUNTRIES" },
  { value: "MG", label: "MADAGASCAR", country: "OTHER COUNTRIES" },
  { value: "MK", label: "MACEDONIA", country: "OTHER COUNTRIES" },
  { value: "MO", label: "MACAU", country: "OTHER COUNTRIES" },
  { value: "LU", label: "LUXEMBOURG", country: "OTHER COUNTRIES" },
  { value: "LT", label: "LITHUANIA", country: "OTHER COUNTRIES" },
  { value: "LI", label: "LEICHTENSTEIN", country: "OTHER COUNTRIES" },
  { value: "LY", label: "LIBYAN ARAB JAMAHIRIYA", country: "OTHER COUNTRIES" },
  { value: "LR", label: "LIBERIA", country: "OTHER COUNTRIES" },
  { value: "LS", label: "LESOTHO", country: "OTHER COUNTRIES" },
  { value: "LB", label: "LEBANON", country: "OTHER COUNTRIES" },
  { value: "LV", label: "LATVIA", country: "OTHER COUNTRIES" },
  { value: "LA", label: "LAO PEOPLES DEMOCTRATIC REPUBL", country: "OTHER COUNTRIES" },
  { value: "KG", label: "KYRGYZSTAN", country: "OTHER COUNTRIES" },
  { value: "KW", label: "KUWAIT", country: "OTHER COUNTRIES" },
  { value: "KR", label: "KOREA, REPUBLIC OF", country: "OTHER COUNTRIES" },
  { value: "KP", label: "KOREA, DEMOCRATIC REPUBLIC OF", country: "OTHER COUNTRIES" },
  { value: "KI", label: "KIRIBATI", country: "OTHER COUNTRIES" },
  { value: "KE", label: "KENYA", country: "OTHER COUNTRIES" },
  { value: "KZ", label: "KAZAKHSTAN", country: "OTHER COUNTRIES" },
  { value: "JO", label: "JORDAN", country: "OTHER COUNTRIES" },
  { value: "JP", label: "JAPAN", country: "OTHER COUNTRIES" },
  { value: "JM", label: "JAMAICA", country: "OTHER COUNTRIES" },
  { value: "IT", label: "ITALY", country: "OTHER COUNTRIES" },
  { value: "IL", label: "ISRAEL", country: "OTHER COUNTRIES" },
  { value: "IE", label: "IRELAND", country: "OTHER COUNTRIES" },
  { value: "IQ", label: "IRAQ", country: "OTHER COUNTRIES" },
  { value: "IR", label: "IRAN (ISLAMIC REPUBLIC OF)", country: "OTHER COUNTRIES" },
  { value: "ID", label: "INDONESIA", country: "OTHER COUNTRIES" },
  { value: "IN", label: "INDIA", country: "OTHER COUNTRIES" },
  { value: "IS", label: "ICELAND", country: "OTHER COUNTRIES" },
  { value: "HU", label: "HUNGARY", country: "OTHER COUNTRIES" },
  { value: "HK", label: "HONG KONG", country: "OTHER COUNTRIES" },
  { value: "HN", label: "HONDURAS", country: "OTHER COUNTRIES" },
  { value: "HM", label: "HEARD AND MC DONALD ISLANDS", country: "OTHER COUNTRIES" },
  { value: "HT", label: "HAITI", country: "OTHER COUNTRIES" },
  { value: "GY", label: "GUYANA", country: "OTHER COUNTRIES" },
  { value: "GW", label: "GUINEA-BISSAU", country: "OTHER COUNTRIES" },
  { value: "GN", label: "GUINEA", country: "OTHER COUNTRIES" },
  { value: "GT", label: "GUATEMALA", country: "OTHER COUNTRIES" },
  { value: "GU", label: "GUAM", country: "OTHER COUNTRIES" },
  { value: "GP", label: "GUADELOUPE", country: "OTHER COUNTRIES" },
  { value: "GD", label: "GRENADA", country: "OTHER COUNTRIES" },
  { value: "GR", label: "GREECE", country: "OTHER COUNTRIES" },
  { value: "GI", label: "GIBRALTAR", country: "OTHER COUNTRIES" },
  { value: "GH", label: "GHANA", country: "OTHER COUNTRIES" },
  { value: "DE", label: "GERMANY", country: "OTHER COUNTRIES" },
  { value: "GM", label: "GAMBIA", country: "OTHER COUNTRIES" },
  { value: "GA", label: "GABON", country: "OTHER COUNTRIES" },
  { value: "TF", label: "FRENCH SOUTHERN TERRITORIES", country: "OTHER COUNTRIES" },
  { value: "PF", label: "FRENCH POLYNESIA", country: "OTHER COUNTRIES" },
  { value: "GF", label: "FRENCH GUIANA", country: "OTHER COUNTRIES" },
  { value: "FX", label: "FRANCE, METROPOLITAN", country: "OTHER COUNTRIES" },
  { value: "FJ", label: "FIJI", country: "OTHER COUNTRIES" },
  { value: "FK", label: "FALKLAND ISLANDS (MALVINAS)", country: "OTHER COUNTRIES" },
  { value: "ET", label: "ETHIOPIA", country: "OTHER COUNTRIES" },
  { value: "FO", label: "FAROE ISLANDS", country: "OTHER COUNTRIES" },
  { value: "EE", label: "ESTONIA", country: "OTHER COUNTRIES" },
  { value: "ER", label: "ERITREA", country: "OTHER COUNTRIES" },
  { value: "GQ", label: "EQUATORIAL GUINEA", country: "OTHER COUNTRIES" },
  { value: "SV", label: "EL SALVADOR", country: "OTHER COUNTRIES" },
  { value: "EG", label: "EGYPT", country: "OTHER COUNTRIES" },
  { value: "EC", label: "ECUADOR", country: "OTHER COUNTRIES" },
  { value: "TL", label: "EAST TIMOR", country: "OTHER COUNTRIES" },
  { value: "DO", label: "DOMINICAN REPUBLIC", country: "OTHER COUNTRIES" },
  { value: "DM", label: "DOMINICA", country: "OTHER COUNTRIES" },
  { value: "DJ", label: "DJIBOUTI", country: "OTHER COUNTRIES" },
  { value: "DK", label: "DENMARK", country: "OTHER COUNTRIES" },
  { value: "CY", label: "CYPRUS", country: "OTHER COUNTRIES" },
  { value: "CU", label: "CUBA", country: "OTHER COUNTRIES" },
  { value: "HR", label: "CROATIA (HRVATSKA)", country: "OTHER COUNTRIES" },
  { value: "CK", label: "COOK ISLANDS", country: "OTHER COUNTRIES" },
  { value: "CG", label: "CONGO PEOPLES REPUBLIC OF", country: "OTHER COUNTRIES" },
  { value: "KM", label: "COMOROS", country: "OTHER COUNTRIES" },
  { value: "CO", label: "COLOMBIA", country: "OTHER COUNTRIES" },
  { value: "CC", label: "COCOS (KEELING) ISLANDS", country: "OTHER COUNTRIES" },
  { value: "CN", label: "CHINA", country: "OTHER COUNTRIES" },
  { value: "CX", label: "CHRISTMAS ISLAND", country: "OTHER COUNTRIES" },
  { value: "CL", label: "CHILE", country: "OTHER COUNTRIES" },
  { value: "TD", label: "CHAD", country: "OTHER COUNTRIES" },
  { value: "CF", label: "CENTRAL AFRICAN REPUBLIC", country: "OTHER COUNTRIES" },
  { value: "KY", label: "CAYMAN ISLANDS", country: "OTHER COUNTRIES" },
  { value: "CV", label: "CAPE VERDE", country: "OTHER COUNTRIES" },
  { value: "CA", label: "CANADA", country: "OTHER COUNTRIES" },
  { value: "CM", label: "CAMEROON", country: "OTHER COUNTRIES" },
  { value: "KH", label: "CAMBODIA", country: "OTHER COUNTRIES" },
  { value: "BI", label: "BURUNDI", country: "OTHER COUNTRIES" },
  { value: "BF", label: "BURKINA FASO", country: "OTHER COUNTRIES" },
  { value: "BN", label: "BRUNEI DARUSSALAM", country: "OTHER COUNTRIES" },
  { value: "IO", label: "BRITISH INDIAN OCEAN TERRITORY", country: "OTHER COUNTRIES" },
  { value: "BR", label: "BRAZIL", country: "OTHER COUNTRIES" },
  { value: "BV", label: "BOUVET ISLAND", country: "OTHER COUNTRIES" },
  { value: "BW", label: "BOTSWANA", country: "OTHER COUNTRIES" },
  { value: "BA", label: "BOSNIA AND HERZEGOWINA", country: "OTHER COUNTRIES" },
  { value: "BO", label: "BOLIVIA", country: "OTHER COUNTRIES" },
  { value: "BT", label: "BHUTAN", country: "OTHER COUNTRIES" },
  { value: "BM", label: "BERMUDA", country: "OTHER COUNTRIES" },
  { value: "BJ", label: "BENIN", country: "OTHER COUNTRIES" },
  { value: "BZ", label: "BELIZE", country: "OTHER COUNTRIES" },
  { value: "BE", label: "BELGIUM", country: "OTHER COUNTRIES" },
  { value: "BY", label: "BELARUS", country: "OTHER COUNTRIES" },
  { value: "BB", label: "BARBADOS", country: "OTHER COUNTRIES" },
  { value: "BD", label: "BANGLADESH", country: "OTHER COUNTRIES" },
  { value: "BS", label: "BAHAMAS", country: "OTHER COUNTRIES" },
  { value: "AZ", label: "AZERBAIJAN", country: "OTHER COUNTRIES" },
  { value: "AU", label: "AUSTRALIA", country: "OTHER COUNTRIES" },
  { value: "AW", label: "ARUBA", country: "OTHER COUNTRIES" },
  { value: "AM", label: "ARMENIA", country: "OTHER COUNTRIES" },
  { value: "AQ", label: "ANTARCTICA", country: "OTHER COUNTRIES" },
  { value: "AI", label: "ANGUILLA", country: "OTHER COUNTRIES" },
  { value: "AO", label: "ANGOLA", country: "OTHER COUNTRIES" },
  { value: "CD", label: "CONGO DEMOCRATIC REPUBLIC OF", country: "OTHER COUNTRIES" },
  { value: "BH", label: "BAHRAIN", country: "OTHER COUNTRIES" },
  { value: "AD", label: "ANDORRA", country: "OTHER COUNTRIES" },
  { value: "AS", label: "AMERICAN SAMOA", country: "OTHER COUNTRIES" },
  { value: "DZ", label: "ALGERIA", country: "OTHER COUNTRIES" },
  { value: "AL", label: "ALBANIA", country: "OTHER COUNTRIES" },
  { value: "AF", label: "AFGHANISTAN", country: "OTHER COUNTRIES" },
  { value: "SY", label: "SYRIAN ARAB REPUBLIC", country: "OTHER COUNTRIES" },
  { value: "FR", label: "FRANCE", country: "OTHER COUNTRIES" },
  { value: "CZ", label: "CZECH REPUBLIC", country: "OTHER COUNTRIES" },
  { value: "AR", label: "ARGENTINA", country: "OTHER COUNTRIES" },
  { value: "GL", label: "GREENLAND", country: "OTHER COUNTRIES" },
  { value: "BG", label: "BULGARIA", country: "OTHER COUNTRIES" },
  { value: "CR", label: "COSTA RICA", country: "OTHER COUNTRIES" },
  { value: "AG", label: "ANTINGUA AND BARBUDA", country: "OTHER COUNTRIES" },
  { value: "FI", label: "FINLAND", country: "OTHER COUNTRIES" },
  { value: "CI", label: "COTE D'IVOIRE", country: "OTHER COUNTRIES" },
  { value: "AT", label: "AUSTRIA", country: "OTHER COUNTRIES" },
  { value: "TW", label: "TAIWAN", country: "OTHER COUNTRIES" },
  { value: "TJ", label: "TAJIKISTAN", country: "OTHER COUNTRIES" },
  { value: "TZ", label: "TANZANIA, UNITED REPUBLIC OF", country: "OTHER COUNTRIES" },
  { value: "TH", label: "THAILAND", country: "OTHER COUNTRIES" },
  { value: "TG", label: "TOGO", country: "OTHER COUNTRIES" },
  { value: "TK", label: "TOKELAU", country: "OTHER COUNTRIES" },
  { value: "TO", label: "TONGA", country: "OTHER COUNTRIES" },
  { value: "TT", label: "TRINIDAD AND TOBAGO", country: "OTHER COUNTRIES" },
  { value: "TN", label: "TUNISIA", country: "OTHER COUNTRIES" },
  { value: "TR", label: "TURKEY", country: "OTHER COUNTRIES" },
  { value: "TM", label: "TURKMENISTAN", country: "OTHER COUNTRIES" },
  { value: "TC", label: "TURKS AND CAICOS ISLANDS", country: "OTHER COUNTRIES" },
  { value: "TV", label: "TUVALU", country: "OTHER COUNTRIES" },
  { value: "UG", label: "UGANDA", country: "OTHER COUNTRIES" },
  { value: "UA", label: "UKRAINE", country: "OTHER COUNTRIES" },
  { value: "AE", label: "UNITED ARAB EMIRATES", country: "OTHER COUNTRIES" },
  { value: "GB", label: "UNITED KINGDOM", country: "OTHER COUNTRIES" },
  { value: "US", label: "UNITED STATES", country: "OTHER COUNTRIES" },
  { value: "UM", label: "US MINOR OUTLYING ISLANDS", country: "OTHER COUNTRIES" },
  { value: "UY", label: "URUGUAY", country: "OTHER COUNTRIES" },
  { value: "VU", label: "VANUATU", country: "OTHER COUNTRIES" },
  { value: "VA", label: "VATICAN CITY STATE (HOLY SEE)", country: "OTHER COUNTRIES" },
  { value: "VE", label: "VENEZUELA", country: "OTHER COUNTRIES" },
  { value: "VN", label: "VIET NAM", country: "OTHER COUNTRIES" },
  { value: "VG", label: "VIRGIN ISLANDS (BRITISH)", country: "OTHER COUNTRIES" },
  { value: "WF", label: "WALLIS AND FUTUNA ISLANDS", country: "OTHER COUNTRIES" },
  { value: "EH", label: "WESTERN SAHARA", country: "OTHER COUNTRIES" },
  { value: "YE", label: "YEMEN", country: "OTHER COUNTRIES" },
  { value: "YU", label: "YUGOSLAVIA", country: "OTHER COUNTRIES" },
  { value: "ZM", label: "ZAMBIA", country: "OTHER COUNTRIES" },
  { value: "ZW", label: "ZIMBABWE", country: "OTHER COUNTRIES" },
  { value: "NV", label: "NEVADA", country: "OTHER COUNTRIES" },
  { value: "GE", label: "GEORGIA", country: "OTHER COUNTRIES" },
];
// Uploading Pre-Rental Photos
export const WECAPTURE_IMAGE_TYPE = {
  preRental: "CUST_PRE_RENTAL",
  rental: "CUST_RENTAL",
  postRental: "CUST_POST_RENTAL",
};
export const WECAPTURE_URL = "https://we-integrate.co.nz/node/hertz/mjp/upload";
export const WECAPTURE_AUTHOR_TYPE = {
  customer: "CUSTOMER",
  staff: "STAFF",
};

//ID Verification /OCRlabs urls
// export const IDVERIFICATION_BASE_URL = "https://secure.carrentalidverify.com";
export const IDVERIFICATION_BASE_URL_DEV = "https://staging.hertz.idkit.co";
export const IDVERIFICATION_BASE_URL = "https://hertz.idkit.co";

export const AU_SEARCHADDRESS = "DataTools.Capture.Address.Predictive.AuPaf.SearchAddress";
export const AU_RETRIEVEADDRESS = "DataTools.Capture.Address.Predictive.AuPaf.RetrieveAddress";
export const AU_REPAIRAADDRESS = "DataTools.Repair.Address.AuPaf.RepairAddress";

export const VERIFYEMAIL = "DataTools.Verify.Email.BriteVerify.VerifyEmail";

export const VERIFYPHONE_AU_NZ =
  "DataTools.Verify.PhoneNumber.Equifax.VerifyPhoneNumberIsConnected";
export const VERIFYPHONE_INT = "DataTools.Verify.PhoneNumber.NumVerify.VerifyPhoneNumber";

export const NZ_SEARCHADDRESS = "DataTools.Capture.Address.Predictive.NzPaf.SearchAddress";
export const NZ_RETRIEVEADDRESS = "DataTools.Capture.Address.Predictive.NzPaf.RetrieveAddress";
export const NZ_REPAIRADDRESS = "DataTools.Verify.Address.NzPaf.VerifyAddress";

export const UK_SEARCHADDRESS = "DataTools.Capture.Address.Predictive.UkPaf.SearchAddress";
export const UK_RETRIEVEADDRESS = "DataTools.Capture.Address.Predictive.UkPaf.RetrieveAddress";
export const UK_REPAIRADDRESS = "DataTools.Verify.Address.IntGdc.VerifyAddress";

export const CANADA_SEARCHADDRESS = "DataTools.Capture.Address.Predictive.CaPaf.SearchAddress";
export const CANADA_RETRIEVEADDRESS = "DataTools.Capture.Address.Predictive.CaPaf.RetrieveAddress";
export const CANADA_REPAIRADDRESS = "DataTools.Verify.Address.IntGdc.VerifyAddress";

export const INTERNATIONAL_SEARCHADDRESS =
  "DataTools.Capture.Address.Predictive.IntPca.SearchAddress";
export const INTERNATIONAL_RETRIEVEADDRESS =
  "DataTools.Capture.Address.Predictive.IntPca.RetrieveAddress";
export const INTERNATION_RETRIEVEADDRESS = "DataTools.Verify.Address.IntGdc.VerifyAddress";

export const AddressSuggestionsWhitelist = [
  "WA",
  "VI",
  "TS",
  "SA",
  "QL",
  "NT",
  "NS",
  "AC",
  "NZ",
  "CA",
  "GB",
  "US",
  "IN",
  "",
];

//Checkin step and complete page icons:
export const HERTZ_STEPS_ICON_1 =
  "https://s3.ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/checkin/hertz/hertz-device.png";
export const HERTZ_STEPS_ICON_2 =
  "https://s3.ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/checkin/hertz/hertz-credit-card.png";
export const HERTZ_STEPS_ICON_3 =
  "https://s3.ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/checkin/hertz/hertz-licence.png";
export const HERTZ_STEPS_ICON_4 =
  "https://s3.ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/checkin/hertz/hertz-selfie.png";

export const THRIFTY_STEPS_ICON_1 =
  "https://s3.ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/checkin/thrifty/thrifty-device.png";
export const THRIFTY_STEPS_ICON_2 =
  "https://s3.ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/checkin/thrifty/thrifty-credit-card.png";
export const THRIFTY_STEPS_ICON_3 =
  "https://s3.ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/checkin/thrifty/thrifty-licence.png";
export const THRIFTY_STEPS_ICON_4 =
  "https://s3.ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/checkin/thrifty/thrifty-selfie.png";

export const DOLLAR_STEPS_ICON_1 =
  "https://s3.ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/checkin/dollar/dollar-device.png";
export const DOLLAR_STEPS_ICON_2 =
  "https://s3.ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/checkin/dollar/dollar-credit-card.png";
export const DOLLAR_STEPS_ICON_3 =
  "https://s3.ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/checkin/dollar/dollar-licence.png";
export const DOLLAR_STEPS_ICON_4 =
  "https://s3.ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/checkin/dollar/dollar-selfie.png";

export const ACE_STEPS_ICON_1 =
  "https://s3.ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/checkin/ace/ace-device.png";
export const ACE_STEPS_ICON_2 =
  "https://s3.ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/checkin/ace/ace-credit-card.png";
export const ACE_STEPS_ICON_3 =
  "https://s3.ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/checkin/ace/ace-licence.png";
export const ACE_STEPS_ICON_4 =
  "https://s3.ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/checkin/ace/ace-selfie.png";

export const HERTZ_COMPLETE_ICON_1 =
  "https://s3.ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/checkin/hertz/hertz-complete-new.png";
export const HERTZ_COMPLETE_ICON_2 =
  "https://s3.ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/checkin/hertz/hertz-licence.png";
export const HERTZ_COMPLETE_ICON_3 =
  "https://s3.ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/checkin/hertz/hertz-credit-card.png";
export const HERTZ_COMPLETE_ICON_4 =
  "https://s3.ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/checkin/hertz/hertz-t&c.png";

export const THRIFTY_COMPLETE_ICON_1 =
  "https://s3.ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/checkin/thrifty/thrifty-complete-new.png";
export const THRIFTY_COMPLETE_ICON_2 =
  "https://s3.ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/checkin/thrifty/thrifty-licence.png";
export const THRIFTY_COMPLETE_ICON_3 =
  "https://s3.ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/checkin/thrifty/thrifty-credit-card.png";
export const THRIFTY_COMPLETE_ICON_4 =
  "https://s3.ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/checkin/thrifty/thrifty-t&c.png";

export const DOLLAR_COMPLETE_ICON_1 =
  "https://s3.ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/checkin/dollar/dollar-complete-new.png";
export const DOLLAR_COMPLETE_ICON_2 =
  "https://s3.ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/checkin/dollar/dollar-licence.png";
export const DOLLAR_COMPLETE_ICON_3 =
  "https://s3.ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/checkin/dollar/dollar-credit-card.png";
export const DOLLAR_COMPLETE_ICON_4 =
  "https://s3.ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/checkin/dollar/dollar-t&c.png";

export const ACE_COMPLETE_ICON_1 =
  "https://s3.ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/checkin/ace/ace-complete-new.png";
export const ACE_COMPLETE_ICON_2 =
  "https://s3.ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/checkin/ace/ace-licence.png";
export const ACE_COMPLETE_ICON_3 =
  "https://s3.ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/checkin/ace/ace-credit-card.png";
export const ACE_COMPLETE_ICON_4 =
  "https://s3.ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/checkin/ace/ace-t&c.png";

export const DOLLAR_THEME_COLOR = "#C80F2E";
export const HERTZ_THEME_COLOR = "#FFCC00";
export const THRIFTY_THEME_COLOR = "#1B7AC3";
export const ACE_THEME_COLOR = "#01396C";

export const MJP_LOGIN_URL_ACE_NZ = "https://portal.staging.hertz.asiapac.io/login?brand=ace";
export const MJP_LOGIN_URL_DOLLAR_AU = "https://portal.staging.hertz.asiapac.io/login?brand=dollar";
export const MJP_LOGIN_URL_ACE_AU = "https://portal.staging.hertz.asiapac.io/login?brand=ace";
export const MJP_LOGIN_URL_DOLLAR_NZ = "https://portal.staging.hertz.asiapac.io/login?brand=dollar";
export const MJP_LOGIN_URL_HERTZ_AU = "https://portal.staging.hertz.asiapac.io/login?brand=hertz";
export const MJP_LOGIN_URL_HERTZ_NZ = "https://portal.staging.hertz.asiapac.io/login?brand=hertz";
export const MJP_LOGIN_URL_THRIFTY_AU =
  "https://portal.staging.hertz.asiapac.io/login?brand=thrifty";
export const MJP_LOGIN_URL_THRIFTY_NZ =
  "https://portal.staging.hertz.asiapac.io/login?brand=thrifty";

export const MJP_LOGIN_URL_LINKS = {
  dev: {
    MJP_LOGIN_URL_ACE_AU: "/login?brand=acerentalcars&country=AU",
    MJP_LOGIN_URL_ACE_NZ: "/login?brand=acerentalcars&country=NZ",
    MJP_LOGIN_URL_DOLLAR_AU: "/login?brand=dollar&country=AU",
    MJP_LOGIN_URL_DOLLAR_NZ: "/login?brand=dollar&country=NZ",
    MJP_LOGIN_URL_HERTZ_AU: "/login?brand=hertz&country=AU",
    MJP_LOGIN_URL_HERTZ_NZ: "/login?brand=hertz&country=NZ",
    MJP_LOGIN_URL_THRIFTY_AU: "/login?brand=thrifty&country=AU",
    MJP_LOGIN_URL_THRIFTY_NZ: "/login?brand=thrifty&country=NZ",
  },
  staging: {
    MJP_LOGIN_URL_ACE_AU: "/login?brand=acerentalcars&country=AU",
    MJP_LOGIN_URL_ACE_NZ: "/login?brand=acerentalcars&country=NZ",
    MJP_LOGIN_URL_DOLLAR_AU: "/login?brand=dollar&country=AU",
    MJP_LOGIN_URL_DOLLAR_NZ: "/login?brand=dollar&country=NZ",
    MJP_LOGIN_URL_HERTZ_AU: "/login?brand=hertz&country=AU",
    MJP_LOGIN_URL_HERTZ_NZ: "/login?brand=hertz&country=NZ",
    MJP_LOGIN_URL_THRIFTY_AU: "/login?brand=thrifty&country=AU",
    MJP_LOGIN_URL_THRIFTY_NZ: "/login?brand=thrifty&country=NZ",
  },
  prod: {
    MJP_LOGIN_URL_ACE_AU: "http://myjourney.acerentalcars.com.au/login",
    MJP_LOGIN_URL_ACE_NZ: "http://myjourney.acerentalcars.co.nz/login",
    MJP_LOGIN_URL_DOLLAR_AU: "http://myjourney.dollarcarrental.com.au/login",
    MJP_LOGIN_URL_DOLLAR_NZ: "http://myjourney.dollarcarrental.co.nz/login",
    MJP_LOGIN_URL_HERTZ_AU: "http://myjourney.hertz.com.au/login",
    MJP_LOGIN_URL_HERTZ_NZ: "http://myjourney.hertz.co.nz/login",
    MJP_LOGIN_URL_THRIFTY_AU: "http://myjourney.thrifty.com.au/login",
    MJP_LOGIN_URL_THRIFTY_NZ: "http://myjourney.thrifty.co.nz/login",
  },
};
